import { render } from "./accounting-onboard.vue?vue&type=template&id=6f579048"
import script from "./accounting-onboard.vue?vue&type=script&lang=js"
export * from "./accounting-onboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__